import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import SnackBar from 'components/common/snack-bar'
import Typo from 'constants/typography'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import styles from './waitlist-snackbar.scss'

const WaitlistSnackBar = ({ isSnackBarOpen, onCloseSnackBar, t }) => (
  <div className="waitlist-snackbar">
    <style jsx>{styles}</style>
    <SnackBar
      className={clsx('waitlist-snackbar__box')}
      duration={4000}
      open={isSnackBarOpen}
      onClose={onCloseSnackBar}
    >
      <div style={{ display: 'flex' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span className={Typo.caption}>
            {hasLocizeTranslation(t, 'WAITLIST_SNACKBAR_TITLE', `Stay tuned!`)}
          </span>
          <span className={Typo.caption}>
            {hasLocizeTranslation(
              t,
              'WAITLIST_SNACKBAR_CONTENT',
              `You'll receive a notification when this product drops. See you soon!`,
            )}
          </span>
        </div>
        <Icon
          src={ICONS.close}
          size={ICON_SIZE.medium}
          onClick={onCloseSnackBar}
        />
      </div>
    </SnackBar>
  </div>
)

WaitlistSnackBar.defaultProps = {
  isSnackBarOpen: false,
}

WaitlistSnackBar.propTypes = {
  isSnackBarOpen: PropTypes.bool,
  onCloseSnackBar: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(WaitlistSnackBar)
